import React from "react";
import Svg from "../Helper/Svg";

const bgColors = {
  primary: "border-transparent bg-theme-accent",
  error: "border-transparent bg-theme-error",
  default: "border-theme-accent",
};

const BaseButton = ({ bgColor, children, disabled, onClick, text, icon, form, type }) => {
  return (
    <button
      className={`flex justify-center items-center w-full border-2 ${bgColors[bgColor]} rounded-default p-default font-medium disabled:opacity-75 disabled:cursor-not-allowed`}
      disabled={disabled}
      form={form}
      onClick={(event) => onClick && onClick(event)}
      type={type}
    >
      {text ?? children}
      {icon ? (
        <span className="ml-2">
          <Svg icon={icon} />
        </span>
      ) : null}
    </button>
  );
};

BaseButton.defaultProps = {
  bgColor: "primary",
  disabled: false,
};

export default BaseButton;
